<template>
    <div class="d-flex flex-column h-100 align-content-center" :style="large?'padding-left: 1.375rem;':''">
        <!--main cards-->
        <div class="d-flex flex-row m-auto position-relative" :class="'card-container'+(large?'-large flex-grow-1':'')">
            <div class="d-flex flex-column left-side-card">
                <!--config manage card-->
                <div class="card-cover tcc-card mb-2">
                    <layout-configuration-title class="w-100"
                                                empty-config-title="空白配置"
                                                config-type-name="图表"
                                                identify-code="table-chart-config"
                                                :key-code="entityName" hide-changed-label
                                                @loadConfig="unpackConfig"></layout-configuration-title>
                </div>
                <!--x axis card-->
                <div class="card-cover x-card">
                    <GroupFieldSelector :fields="categoryFields"
                                        :selected-fields.sync="xAxisFields"
                                        :date-split-unit.sync="dateSplitUnit"></GroupFieldSelector>
                </div>
                <!--y axis card-->
                <div class="card-cover mt-2 y-card d-flex flex-column flex-grow-1"
                     :class="isYFieldsUnavailable?'justify-content-center':''">
                    <draggable v-if="!isYFieldsUnavailable" v-model="yAxisFieldsWithSeg" v-bind="{animation: 500}">
                        <transition-group>
                            <div v-for="(field,index) of yAxisFieldsWithSeg" :key="index">
                                <template v-if="field.isSeg">
                                    <div class="seq-cover" @click="removeSeg(index)"></div>
                                </template>
                                <template v-else>
                                    <div class="d-flex flex-row align-content-center mt-1 p-1"
                                         @click="yAxisItemClick(field)">
                                        <b-badge variant="light" class="badge-text ml-2 position-relative">
                                            {{ fieldLabel(field.item) }}
                                            <div v-if="field.key===sortBy" class="dot"
                                                 style="background-color:#3d70b0;"></div>
                                        </b-badge>
                                        <b-badge variant="primary" class="h-min-content ml-1"
                                                 v-if="field.aggregation && field.aggregation !== 'SUM'">
                                            {{ field.aggregation }}
                                        </b-badge>
                                        <b-badge variant="warning" class="h-min-content ml-1"
                                                 v-if="isFieldGrouped(field)">
                                            {{ field.groupBy.fields.length }}
                                        </b-badge>

                                        <b-button pill
                                                  class="ml-auto mr-2"
                                                  @click="switchChartType(field.item.key, index)"
                                                  variant="light">
                                            <i class="fa-solid" :class="chartIcon[chartTypeMap[field.item.key]]"></i>
                                        </b-button>
                                    </div>
                                </template>
                            </div>
                        </transition-group>
                    </draggable>
                    <div class="d-flex flex-row justify-content-center">
                        <h5 v-if="isYFieldsUnavailable">无可用数据</h5>
                        <template v-else>
                            <b-button class="mt-1 w-25 ml-1"
                                      @click="addNewSeg"
                                      variant="light">
                                <i class="fa-solid fa-diagram-next"></i>
                            </b-button>
                            <b-dropdown class="mt-1 w-25 ml-1"
                                        boundary="window"
                                        dropright
                                        no-caret
                                        variant="light"
                                        @shown="cancelHideTag=true"
                                        @hide="cancelHide">
                                <template #button-content>
                                    <i class="fa-solid fa-plus"></i>
                                </template>
                                <template v-for="item of numberFields">
                                    <b-dropdown-item-button :key="item.key"
                                                            :active="isYFieldSelected(item)"
                                                            @click="addYAxisField(item)">
                                        {{ fieldLabel(item) }}
                                    </b-dropdown-item-button>
                                </template>
                            </b-dropdown>
                            <b-button class="mt-1 w-50 ml-1 mr-1"
                                      @click="newExpressBtnClick"
                                      variant="light">
                                <i class="fa-solid fa-terminal"></i>
                            </b-button>
                        </template>
                    </div>
                </div>
                <!--config change card-->
                <div class="card-cover mt-2 config-card" v-if="selectedYField">
                    <div class="d-flex flex-column m-2">
                        <div class="d-flex flex-row temp-cover">
                            <div v-if="fieldLabelEditing"
                                 class="d-flex flex-row w-100 ml-2 mr-1">
                                <b-form-input
                                    :value="selectedYField.item.label"
                                    autofocus
                                    @update="selectedYField.item.label=$event"
                                    @blur="fieldLabelEditing=false">
                                </b-form-input>
                            </div>
                            <template v-else>
                                <b-badge variant="light" class="badge-text"
                                         @click="fieldLabelEditing=true">
                                    {{ fieldLabel(selectedYField.item) }}
                                </b-badge>
                                <delete-button class="del-btn-cover ml-auto"
                                               :addition-text="selectedYField.item.label || selectedYField.key"
                                               @btnClick="deleteField(selectedYField.key)">
                                </delete-button>
                            </template>
                        </div>
                        <b-button-group class="mt-1">
                            <b-button variant="outline-primary"
                                      @click="switchAggregation(selectedYField)">
                                {{ selectedYField.aggregation }}
                            </b-button>
                            <b-button v-if="isFieldGrouped(selectedYField)"
                                      :variant="selectedYField.groupBy.stacked?'primary':'outline-primary'"
                                      @click="switchGroupByStacked(selectedYField)">
                                <i class="fa-solid fa-layer-group"></i>
                            </b-button>
                            <b-button v-if="selectedYField.item.isCustomized"
                                      :variant="selectedYFieldItem==null?'outline-primary':'success'"
                                      @click="editExpress(selectedYField.item)">
                                <i class="fa-solid fa-subscript"></i>
                            </b-button>
                        </b-button-group>
                        <sort-switch
                            v-if="!isXAxisTypeDate && (!selectedYField.groupBy.fields || selectedYField.groupBy.fields.length === 0)"
                            class="mt-1"
                            :sorting-by.sync="sortBy"
                            :desc.sync="sortDesc"
                            :current-key="selectedYField.key"></sort-switch>
                        <group-field-selector :fields="filteredCategoryFields"
                                              :selected-fields.sync="selectedYField.groupBy.fields"
                                              :date-split-unit.sync="selectedYField.groupBy.dateSplitUnit"
                                              @selected="sortBy=null;sortDesc=false;"></group-field-selector>
                    </div>
                </div>
            </div>
            <!--chart view card-->
            <div class="card-cover ml-2" :class="'chart-card'+(large?'-large':'')" ref="chartCard">
                <table-chart-viewer ref="chartViewer" v-if="chartLazyLoad" :options="chartConfig"
                                    :rows="tableRows"></table-chart-viewer>
            </div>

        </div>
        <!--expression card-->
        <div class="card-cover expression-card mt-2 position-relative" v-if="expressionCardVisible">
            <ExpressionGenerator ref="expressionGenerator"
                                 class="h-100"
                                 :variables="translatedNumberFields"></ExpressionGenerator>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import ExpressionGenerator from "@/components/echarts-part/TableChart/cell/ExpressionGenerator.vue";
import ExpressionMixins from "@/components/echarts-part/TableChart/mixins/ExpressionMixins";
import TableChartMixins, {AGGREGATION} from "@/components/echarts-part/TableChart/mixins/TableChartMixins";
import TableChartViewer from "@/components/echarts-part/TableChart/cell/TableChartViewer.vue";
import GroupFieldSelector from "@/components/echarts-part/TableChart/cell/GroupFieldSelector";
import DeleteButton from "@/components/common/buttons/DeleteButton.vue";
import SortSwitch from "@/components/common/buttons/SortSwitch.vue";
import LayoutConfigurationTitle from "@/components/common/mini-table/cells/LayoutConfigurationTitle.vue";

let COUNT_SUM = {
    label: '计数',
    key: '__count_sum',
    isCountSum: true,
    isAppend: true
};

export default {
    name: "TableChartConfigure",
    components: {
        LayoutConfigurationTitle,
        SortSwitch,
        DeleteButton, GroupFieldSelector, TableChartViewer, ExpressionGenerator, draggable
    },
    mixins: [emCommonUtilMixin, ExpressionMixins, TableChartMixins],
    props: {
        large: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        $_xAxisFields() {
            return this.xAxisFields;
        },
        $_dateSplitUnit() {
            return this.dateSplitUnit;
        },
        chartTypes() {
            return Object.keys(this.chartIcon);
        },
        filteredCategoryFields() {
            let tempList = [];
            for (let item of this.categoryFields) {
                if (!this.isFieldSelected(this.xAxisFields, item)) {
                    tempList.push(item);
                }
            }
            return tempList;
        },
        categoryFields() {//Available X axis columns, to choose
            let tempList = [];
            for (let f of this.tableFields) {
                if (this.isFieldTypeDate(f) || this.isFieldTypeString(f)) {
                    tempList.push(f);
                }
            }
            return tempList;
        },
        numberFields() {//Available Y axis fields, to choose
            let tempList = [];
            if (!this.isXAxisTypeDate || this.isXAxisTimeSplit) {
                tempList.push(COUNT_SUM);
            }
            for (let f of this.tableFields) {
                let type = f.form.type;
                if (type === 'inputNumber') {
                    tempList.push(f);
                } else {
                    let bad = false;
                    let hasValue = false;
                    for (let row of this.tableRows) {
                        let cell = row[f.key];
                        if (cell) {
                            if (isNaN(cell) && isNaN(Date.parse(cell))) {
                                bad = true;
                                break;
                            }
                            hasValue = true;
                        }
                    }
                    if (!bad && hasValue) {
                        tempList.push(f);
                    }
                }
            }
            return tempList;
        },
        isYFieldsUnavailable() {
            return this.numberFields.length === 0;
        },
        chartConfig() {
            let tempList = [];
            let list = this.yAxisFieldsWithSeg;
            for (let i = 0; i < list.length; i++) {
                let item = list[i];
                if (item.isSeg) {
                    tempList.push(item);
                } else {
                    let temp = {
                        type: this.chartTypeMap[item.key].toLowerCase(),
                        item: item.item,
                        key: item.key,
                        groupBy: item.groupBy,
                        aggregation: item.aggregation
                    };
                    if (item.key === this.sortBy) {
                        temp.sortDesc = this.sortDesc;
                    }
                    tempList.push(temp);
                }
            }
            if (this.needRedrawFlag > 0) {
                // console.log('redraw');
            }
            return {
                list: tempList,
                xAxisFields: this.xAxisFields,
                dateSplitUnit: this.dateSplitUnit
            };
        },
        translatedNumberFields() {
            let tempList = [];
            for (let item of this.numberFields) {
                if (item.isAppend) {
                    continue;
                }
                tempList.push({
                    label: this.fieldLabel(item),
                    key: item.key
                });
            }
            return tempList;
        },
        expressionCardVisible() {
            return this.selectedYFieldItem != null;
        },
    },
    data() {
        return {
            entityName: "",
            tableFields: [],
            tableRows: [],

            xAxisFields: [],
            yAxisFieldsWithSeg: [],

            chartIcon: {
                LINE: 'fa-chart-line',
                BAR: 'fa-chart-column',
                PIE: 'fa-chart-pie'
            },
            chartTypeMap: {},
            chartLazyLoad: false,

            cancelHideTag: true,//取消自动隐藏下拉弹出框
            dateSplitUnit: -1,
            //----expression generate
            selectedYFieldItem: null,
            selectedYField: null,
            sortBy: null,
            sortDesc: false,
            //-----
            needRedrawFlag: 1,

            fieldLabelEditing: false
        }
    },
    watch: {
        yAxisFieldsWithSeg() {
            for (let i = 0; i < this.yAxisFieldsWithSeg.length; i++) {
                let item = this.yAxisFieldsWithSeg[i];
                if (!item.isSeg && this.chartTypeMap[item.key] === 'PIE') {
                    if (!this.isYAxisFieldSingle(i)) {
                        this.switchChartType(item.key, i);
                    }
                }
            }
        },
        selectedYField: {
            handler() {
                this.needRedrawFlag += 1;
                if (this.needRedrawFlag > 10000) {
                    this.needRedrawFlag = 1;
                }
                this.$forceUpdate();
            },
            deep: true
        },
        expressionCardVisible() {
            this.$refs.chartViewer.resize();
        },
    },
    methods: {
        initializeData(fields, rows, entityName) {
            this.tableFields = fields;
            this.tableRows = rows;
            this.entityName = entityName;
        },
        addYAxisField(item) {
            this.changeAxisFieldList(this.yAxisFieldsWithSeg, {
                key: item.key,
                item: item
            });
            this.$set(this.chartTypeMap, item.key, this.chartTypes[0])
        },
        addYAxisCustomizedField() {
            let id = this.genNonDuplicateID(4);
            this.yAxisFieldsWithSeg.push({
                key: id,
                item: {
                    key: id,
                    label: '',
                    isCustomized: true,
                    expression: ''
                }
            })
            this.$set(this.chartTypeMap, id, this.chartTypes[0])
        },
        removeYAxisField(index) {
            this.$delete(this.chartTypeMap, this.yAxisFieldsWithSeg[index].id)
            this.removeField(this.yAxisFieldsWithSeg, index);
        },
        isYFieldSelected(item) {
            return this.isFieldSelected(this.yAxisFieldsWithSeg, item);
        },
        switchChartType(key, fieldIndex) {
            let nextType = this.getNextChartType(key, fieldIndex);
            if (nextType) {
                this.$set(this.chartTypeMap, key, nextType);
            }
        },
        getFieldIndexByKey(key) {
            for (let i = 0; i < this.yAxisFieldsWithSeg.length; i++) {
                if (this.yAxisFieldsWithSeg[i].key === key) {
                    return i;
                }
            }
            return -1;
        },
        getNextChartType(key, fieldIndex) {
            let value = this.chartTypeMap[key];
            if (fieldIndex === undefined) {
                fieldIndex = this.getFieldIndexByKey(key);
                if (fieldIndex < 0) {
                    return;
                }
            }
            for (let i = 0; i < this.chartTypes.length; i++) {
                if (this.chartTypes[i] === value) {
                    let nextIndex = i;
                    do {
                        nextIndex = nextIndex + 1;
                        if (nextIndex >= this.chartTypes.length) {
                            nextIndex = 0;
                        }
                    } while ((!this.isYAxisFieldSingle(fieldIndex) || (this.isXAxisTypeDate && !this.isXAxisTimeSplit)) && this.chartTypes[nextIndex] === 'PIE');
                    return this.chartTypes[nextIndex];
                }
            }
        },
        isYAxisFieldSingle(fieldIndex) {
            return (fieldIndex === 0 || this.yAxisFieldsWithSeg[fieldIndex - 1].isSeg)
                && (fieldIndex === this.yAxisFieldsWithSeg.length - 1 || this.yAxisFieldsWithSeg[fieldIndex + 1].isSeg);
        },
        addNewSeg() {
            let list = this.yAxisFieldsWithSeg;
            if (list.length === 0) {
                return;
            }
            if (list[0].isSeg) {
                list.splice(0, 1);
            }
            if (list[list.length - 1].isSeg) {
                list.pop();
            } else {
                list.push({isSeg: true});
            }
        },
        removeSeg(index) {
            let temp = this.yAxisFieldsWithSeg[index];
            if (temp.isSeg) {
                this.yAxisFieldsWithSeg.splice(index, 1);
            }
        },
        cancelHide(event) {
            if (this.cancelHideTag) {
                event.preventDefault();
                this.cancelHideTag = false;
            }
        },
        yAxisItemClick(field) {
            if (!field.groupBy) {
                field.groupBy = {};
            }
            if (!field.aggregation) {
                field.aggregation = AGGREGATION.SUM;
            }
            if (this.selectedYField && this.selectedYField.key === field.key) {
                this.selectedYField = null;
                this.selectedYFieldItem = null;
            } else {
                this.selectedYField = field;
            }
        },
        //click item to edit
        editExpress(item) {
            if (this.selectedYFieldItem != null) {
                this.finishExpressEdit();
            } else if (item.isCustomized) {
                this.selectedYFieldItem = item;
                this.$nextTick(() => this.$refs.expressionGenerator.initExpression(this.selectedYFieldItem.expression));
            } else {
                this.selectedYFieldItem = null;
            }
        },
        //when click new express button, finish edit or create new one
        newExpressBtnClick() {
            this.addYAxisCustomizedField();
        },
        finishExpressEdit() {
            if (this.saveExpress()) {
                this.selectedYFieldItem = null;
            }
        },
        //save expression str
        saveExpress() {
            let expressStr = this.$refs.expressionGenerator.getExpressStr();
            if (expressStr == null) {
                return false;
            } else {
                this.selectedYFieldItem.expression = expressStr;
                return true;
            }
        },
        //------
        switchAggregation(field) {
            let found = false;
            for (let k of Object.keys(AGGREGATION)) {
                if (k === field.aggregation) {
                    found = true;
                } else if (found) {
                    this.$set(field, 'aggregation', AGGREGATION[k]);
                    return;
                }
            }
            this.$set(field, 'aggregation', AGGREGATION.SUM);
        },
        switchGroupByStacked(field) {
            this.$set(field.groupBy, 'stacked', !field.groupBy.stacked);
        },
        deleteField(key) {
            for (let i = 0; i < this.yAxisFieldsWithSeg.length; i++) {
                if (this.yAxisFieldsWithSeg[i].key === key) {
                    this.removeYAxisField(i);
                    this.selectedYFieldItem = null;
                    this.selectedYField = null;
                    break;
                }
            }
        },
        //------
        gatherConfig() {
            return this.getCurrentConfigObject();
        },
        unpackConfig(temp) {
            if (temp == null) {
                temp = {
                    x: [],
                    y: [],
                    typeMap: {},
                    dateSplitUnit: -1,
                    sortBy: null,
                    sortDesc: false,
                };
            } else {
                temp = JSON.parse(temp.configuration);
            }
            this.xAxisFields = temp.x;
            this.yAxisFieldsWithSeg = temp.y;
            this.chartTypeMap = temp.typeMap;
            this.dateSplitUnit = temp.dateSplitUnit;
            this.sortBy = temp.sortBy;
            this.sortDesc = temp.sortDesc;
            this.chartLazyLoad = false;
            this.$nextTick(() => this.$nextTick(() => this.chartLazyLoad = true));
        },
        getCurrentConfigObject() {
            return {
                x: this.xAxisFields,
                y: this.yAxisFieldsWithSeg,
                typeMap: this.chartTypeMap,
                dateSplitUnit: this.dateSplitUnit,
                sortBy: this.isXAxisTypeDate ? null : this.sortBy,
                sortDesc: this.isXAxisTypeDate ? false : this.sortDesc,
            }
        },
    },
};
</script>

<style scoped>
.card-cover {
    background-color: #ffffff;
    border-radius: 15px;
    overflow: auto;
}

.card-cover::-webkit-scrollbar {
    display: none; /* Chrome Safari */
}

.card-container {
    height: 600px;
}

.card-container-large {
    height: calc(100% - 160px);
    width: 100%;
}

.left-side-card {
    width: 200px;
}

.x-card {
    width: 100%;
    height: max-content;
    padding: 1rem .5rem;
}

.y-card {
    width: 100%;
}

.config-card {
    width: 100%;
    height: max-content;
}

.chart-card {
    width: 600px;
    height: 100%;
}

.chart-card-large {
    width: calc(100% - 210px);
}

.badge-text {
    font-size: .8rem;
    padding: .5rem;
}

.h-min-content {
    height: min-content;
}

.seq-cover {
    background-image: linear-gradient(90deg, #808080, #3b3b3b, #c3c3c3);
    height: 2px;
    width: 90%;
    margin: 1px auto 1px auto;
    border-radius: 1px;
    cursor: pointer;
}

.expression-card {
    width: 100%;
    height: 150px;
}

.temp-cover {
    position: relative;
}

.del-btn-cover {
    transform: translateX(100%);
    transition: transform .3s ease-in-out;
}

.temp-cover:hover .del-btn-cover {
    transform: translateX(0) !important;
}

.dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
}

.tcc-card {
    overflow: unset !important;
    padding: .25rem .5rem 0 .5rem;
    width: 100%;
}

.tcc-card >>> h4 {
    white-space: break-spaces;
    width: max-content;
}
</style>
